import { render, staticRenderFns } from "./TrendDeclinePanel.vue?vue&type=template&id=8d525df8&scoped=true&"
import script from "./TrendDeclinePanel.vue?vue&type=script&lang=js&"
export * from "./TrendDeclinePanel.vue?vue&type=script&lang=js&"
import style0 from "./TrendDeclinePanel.vue?vue&type=style&index=0&id=8d525df8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d525df8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VChip,VIcon,VSpacer,VTextField})
